import { render, staticRenderFns } from "./TransitionMath.vue?vue&type=template&id=5d01eb39&scoped=true&lang=pug&"
import script from "./TransitionMath.vue?vue&type=script&lang=ts&"
export * from "./TransitionMath.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionMath.vue?vue&type=style&index=0&id=5d01eb39&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01eb39",
  null
  
)

export default component.exports